function n(n,r){if(null==n)return{};var e={};for(var i in n)if({}.hasOwnProperty.call(n,i)){if(r.includes(i))continue;e[i]=n[i]}return e}export{n as default};
//# sourceMappingURL=objectWithoutPropertiesLoose.js.map
